// 1. Create an invisible iframe to bypass the theme's silencer
const iframe = document.createElement('iframe');
iframe.style.display = 'none';
document.body.appendChild(iframe);

// 2. Steal its untouched console.log and warn functions
const realLog = iframe.contentWindow.console.log;
const realWarn = iframe.contentWindow.console.warn;

window.gbEvents = window.gbEvents || [];

function testCode() {
	realLog('test is running');
	(function () {
		const FREE_SHIPPING_THRESHOLD = 45.0;

		function init() {
			if (document.querySelector('.bb-shipping-wrapper')) return;

			const target = document.querySelector(`[data-modal-label="Your cart"] > div`);
			const subtotalEl = document.querySelector(`.wsgAjaxSubtotal`);

			if (!target || !subtotalEl) return;

			const html = `
            <style>
                .bb-shipping-wrapper {
                    padding: 15px 20px 5px 20px;
                    width: 100%;
                    box-sizing: border-box;
					padding-left: var(--section-x-padding);
    				padding-right: var(--section-x-padding);
                }
                .bb-shipping-bar {
                    background-color: #e5e5e5;
                    border-radius: 10px;
                    height: 20px;
                    width: 100%;
                    margin-bottom: 12px;
                    overflow: hidden;
                }
                .bb-shipping-progress {
                    background-color: #ba164c; 
                    height: 100%;
                    width: 0%;
                    border-radius: 10px;
                    transition: width 0.4s ease-in-out;
                }
                .bb-shipping-text {
                    text-align: center;
                    font-size: 18px;
                    color: #111;
                    margin: 0;
                    font-family: inherit;
					margin-top: 20px;
    				margin-bottom: 20px;
                }
            </style>
            <div class="bb-shipping-wrapper">
                <div class="bb-shipping-bar">
                    <div class="bb-shipping-progress"></div>
                </div>
                <div class="bb-shipping-text"></div>
            </div>
        `;

			target.insertAdjacentHTML('afterend', html);

			function updateSlider() {
				const currentSubtotalEl = document.querySelector('.wsgAjaxSubtotal');
				if (!currentSubtotalEl) return;

				const text = currentSubtotalEl.innerText || currentSubtotalEl.textContent;

				const subtotal = parseFloat(text.replace(/[^0-9.]/g, ''));
				if (isNaN(subtotal)) return;

				const progressEl = document.querySelector('.bb-shipping-progress');
				const textEl = document.querySelector('.bb-shipping-text');

				if (!progressEl || !textEl) return;

				if (subtotal >= FREE_SHIPPING_THRESHOLD) {
					progressEl.style.width = '100%';
					textEl.innerHTML = 'You qualify for free shipping!';
				} else {
					const remaining = (FREE_SHIPPING_THRESHOLD - subtotal).toFixed(2);
					const percentage = Math.min((subtotal / FREE_SHIPPING_THRESHOLD) * 100, 100);

					progressEl.style.width = percentage + '%';
					textEl.innerHTML = `You are $${remaining} away from <strong>Free Shipping!</strong>`;
				}
			}

			updateSlider();

			const observer = new MutationObserver(function () {
				updateSlider();
			});

			observer.observe(subtotalEl, {
				childList: true,
				characterData: true,
				subtree: true,
			});
		}

		console.log(
			'%cBB-07 Cart Drawer free shipping threshold',
			"color: white; background-color:#202621; font-weight: bold; font-family:'SpaceGrotesk', sans-serif;",
		);

		function poll(sel, cb) {
			setTimeout(function () {
				if (document.querySelector(sel) && document.querySelector('.wsgAjaxSubtotal')) {
					cb();
				} else {
					poll(sel, cb);
				}
			}, 50);
		}

		poll('[data-modal-label="Your cart"] > div', init);
	})();
}

// --->  MANUAL A/B TEST RANDOMIZER <---
(function () {
	const preview = true;

	// =========================================================================
	// ---> TEST TARGETING CONFIGURATION
	// =========================================================================
	const config = {
		// URL Filtering
		filterByUrls: false,
		allowedUrls: ['/products/'], // Only fires if current URL contains one of these strings

		// Device Filtering
		allowMobile: true,
		allowDesktop: true,
	};

	// Helper: Check if current URL is allowed
	function isUrlAllowed() {
		if (!config.filterByUrls) return true;
		// Using .includes() ensures query parameters won't break the match
		return config.allowedUrls.some((url) => window.location.href.includes(url));
	}

	function isDeviceAllowed() {
		const mobileBreakpoint = 768;
		const isMobile = window.innerWidth < mobileBreakpoint;

		if (isMobile && !config.allowMobile) return false;
		if (!isMobile && !config.allowDesktop) return false;

		return true;
	}

	// Evaluate targeting before running test or preview logic
	if (!isUrlAllowed() || !isDeviceAllowed()) {
		realLog('Test skipped: Does not meet URL or Device targeting rules.');
		return; // Exit out of the A/B test wrapper entirely
	}
	// =========================================================================

	if (!preview) {
		//CHANGE PER TEST: APPEARS AS TEST NAME IN GA4
		const cookieName = 'ab_test_variant';

		// Helper to read cookies
		function getCookie(name) {
			const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
			return match ? match[2] : null;
		}

		// Check if user already has a variant cookie
		let variant = getCookie(cookieName);

		// If they are new, flip a coin (50/50 split) and assign them
		if (!variant) {
			variant = Math.random() < 0.5 ? 'control' : 'v1';

			// Write cookie so variant follows them everywhere (expires in 30 days)
			const date = new Date();
			date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
			document.cookie = cookieName + '=' + variant + ';expires=' + date.toUTCString() + ';path=/';
		}

		// =========================================================================
		// ---> SEND DIRECTLY TO GA4
		// =========================================================================
		window.dataLayer = window.dataLayer || [];
		function gtag() {
			dataLayer.push(arguments);
		}

		gtag('set', 'user_properties', {
			ab_test_variant: variant,
		});

		gtag('event', 'experiment_impression', {
			send_to: 'G-Y4VGNLBJPF',
			debug_mode: false,
		});
		// =========================================================================

		// Run the visual changes
		if (variant === 'v1') {
			realLog('MANUAL TEST: Variation active');
			testCode();
		} else {
			realLog('MANUAL TEST: Control active');
		}

		// Send the page view goal (if you still have a separate tracker looking for gbEvents)
		window.gbEvents.push('Page View');

		if (document.readyState === 'complete') {
			initQuickCheckoutTracking();
		} else {
			window.addEventListener('load', initQuickCheckoutTracking);
		}
	} else if (window.location.href.includes('bb07-preview')) {
		realLog('%cPreview mode ACTIVE', "color: #F7F631; background-color:black; font-weight: bold; font-family:'SpaceGrotesk', sans-serif;");
		testCode();
	}
})();
